import React from 'react';

const Team = ({ height = 48, width = 48, color = '#335262', secondaryColor = '#5a7a84' }) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <title>team</title>
    <g>
      <path d="M44.367,31.343l-7.9-2.872a1,1,0,0,1-.65-.8l-.405-2.836A9.024,9.024,0,0,0,40,17V11.072a5.371,5.371,0,0,0-4.727-5.326L34.4,4a1.842,1.842,0,0,0-2.239-.9L26.774,5.025A7.456,7.456,0,0,0,22.9,8.508,11.375,11.375,0,0,1,27,17.274V19a16.391,16.391,0,0,0,2.5,7.336,3,3,0,0,1-1.157,4.349,7.309,7.309,0,0,1-.993.386l1.378.413A5.966,5.966,0,0,1,33,37.232V42a2.966,2.966,0,0,1-.184,1H46a1,1,0,0,0,1-1V35.1A4.01,4.01,0,0,0,44.367,31.343Z" fill={color} />
      <path d="M30,43H2a1,1,0,0,1-1-1V37.232A3.977,3.977,0,0,1,3.851,33.4l6.637-1.991a1,1,0,0,0,.7-.816l.162-1.125c-4.285.651-6.688-.519-6.8-.573a1,1,0,0,1-.385-1.45A18.144,18.144,0,0,0,7,19V17a9,9,0,0,1,9.6-8.98A9.162,9.162,0,0,1,25,17.274V19a18.144,18.144,0,0,0,2.832,8.445,1,1,0,0,1-.385,1.45c-.11.054-2.513,1.223-6.8.573l.162,1.125a1,1,0,0,0,.7.816L28.149,33.4A3.977,3.977,0,0,1,31,37.232V42A1,1,0,0,1,30,43Z" fill={secondaryColor} />
    </g>
  </svg>
);


export default Team;
